document.addEventListener("DOMContentLoaded", function() {

    // hamburger
    const hamburger = document.querySelector('.JS-hamburger-toggle');
    const body = document.body;

    if (hamburger) {
        hamburger.addEventListener('click', function() {
            body.classList.toggle('menu-is-open');
        });
    }

    // submenu
    document.querySelectorAll('.JS-submenu-toggle').forEach(item => {
        let timeout;

        item.addEventListener('click', function(e) {
            const isArrow = e.target.closest('.sub-arrow');

            if (isArrow) {
                // Pokud klikne na šipku, nechceme, aby se spustil odkaz v <a>
                e.preventDefault();
                // Zabráníme probublávání eventu nahoru
                e.stopPropagation();
                // Jen přepneme třídu pro rozbalení
                this.classList.toggle('is-active');
            }
        });

        item.addEventListener('mouseenter', () => {
            if (window.innerWidth > 1024) {
                clearTimeout(timeout);
                item.classList.add('is-active');
            }
        });

        item.addEventListener('mouseleave', () => {
            if (window.innerWidth > 1024) {
                timeout = setTimeout(() => {
                    item.classList.remove('is-active');
                }, 300);
            }
        });
    });


});